// services/frontend/src/components/signup/SignupFixedBottomButton.jsx
import React from 'react';

/**
 * [Why]
 * RN 앱의 하단 고정 CTA 버튼(FixedBottomButton) UX를 웹에서 동일하게 제공하기 위한 컴포넌트입니다.
 *
 * [How]
 * - 화면 하단에 고정된 버튼 영역을 렌더링합니다.
 * - enabled 여부에 따라 컬러/커서/disabled를 통일합니다.
 */
export default function SignupFixedBottomButton({
  label,
  onClick,
  disabled = false,
  loading = false,
}) {
  const enabled = !disabled && !loading;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        padding: 16,
        background: 'rgba(255,255,255,0.96)',
        borderTop: '1px solid #f3f4f6',
      }}
    >
      {/* [웹 UX] */}
      {/* - 하단 고정 CTA는 화면 전체폭으로 늘어나기 쉬우므로, 회원가입 정책(최대 800px)에 맞춰 폭을 제한합니다. */}
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <button
          type="button"
          onClick={onClick}
          disabled={!enabled}
          style={{
            width: '100%',
            height: 46,
            borderRadius: 12,
            border: '1px solid #6366f1',
            background: enabled ? 'linear-gradient(180deg,#c7d2fe 0%,#a5b4fc 100%)' : '#f3f4f6',
            color: enabled ? '#1e1b4b' : '#9ca3af',
            cursor: enabled ? 'pointer' : 'not-allowed',
            fontSize: 16,
            fontWeight: 600,
          }}
        >
          {loading ? '처리 중...' : label}
        </button>
      </div>
    </div>
  );
}
